import "./IntroBannerCategorias .css";
import { useNavigate } from "react-router-dom";
import {
  useMemo,
  useRef,
  useState,
  useEffect,
} from "react";
import { verificaAdmin } from "../../../../components/utils/verificaAdmin";
import AdminBannerCategoria from "./AdminBannerCategoria/AdminBannerCategoria";

function IntroBannerCategorias({
  banners,
  loading,
  atualizarBanners
}) {
  const [podeEsquerda, setPodeEsquerda] = useState(false);
  const [podeDireita, setPodeDireita] = useState(false);

  const navigate = useNavigate();
  const containerRef = useRef(null);

  const [abrirAdmin, setAbrirAdmin] =
    useState(false);

  const isAdmin =
    verificaAdmin();

  const categorias = useMemo(() => {
    return (
      banners
        ?.filter(
          (b) =>
            b.localizacao ===
            "introbannercategoria"
        )
        .sort(
          (a, b) =>
            Number(a.id) -
            Number(b.id)
        ) || []
    );
  }, [banners]);

  const SCROLL_STEP = 1200;

  const scrollLeft = () => {
    containerRef.current?.scrollBy({
      left: -SCROLL_STEP,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    containerRef.current?.scrollBy({
      left: SCROLL_STEP,
      behavior: "smooth",
    });
  };


  useEffect(() => {
    atualizarBotoes();

    const el = containerRef.current;

    if (!el) return;

    el.addEventListener(
      "scroll",
      atualizarBotoes
    );

    window.addEventListener(
      "resize",
      atualizarBotoes
    );

    return () => {
      el.removeEventListener(
        "scroll",
        atualizarBotoes
      );

      window.removeEventListener(
        "resize",
        atualizarBotoes
      );
    };
  }, [categorias]);


  const atualizarBotoes = () => {
    const el = containerRef.current;

    if (!el) return;

    setPodeEsquerda(el.scrollLeft > 0);

    setPodeDireita(
      el.scrollLeft + el.clientWidth <
      el.scrollWidth - 2
    );
  };


  if (loading) return null;

  if (
    categorias.length === 0 &&
    !isAdmin
  ) {
    return null;
  }

  return (
    <section className="IntroBannerCategorias-wrapper">

      {isAdmin && (
        <div
          style={{
            display: "flex",
            justifyContent:
              "flex-end",
            marginBottom: "10px",
          }}
        >
          <button
            className="btn-editar-categorias"
            onClick={() =>
              setAbrirAdmin(true)
            }
          >
            Editar
          </button>
        </div>
      )}

      {categorias.length === 0 &&
        isAdmin && (
          <div
            style={{
              minHeight: "120px",
              border:
                "2px dashed #ccc",
              borderRadius: "8px",
              display: "flex",
              alignItems:
                "center",
              justifyContent:
                "center",
              marginBottom:
                "20px",
            }}
          >
            <h3
              style={{
                margin: 0,
              }}
            >
              Banners Categorias
            </h3>
          </div>
        )}

      {categorias.length > 0 && (
        <>
          <h2 className="IntroBannerCategorias-title">
            Veja outras categorias
          </h2>

          {podeEsquerda && (
            <button
              className="IntroBannerCategorias-scrollBtn IntroBannerCategorias-scrollBtn-left"
              onClick={
                scrollLeft
              }
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
          )}

          <div
            className="IntroBannerCategorias-container"
            ref={containerRef}
          >
            <div className="IntroBannerCategorias-block">
              {categorias.map(
                (cat) => (
                  <div
                    className="IntroBannerCategorias-card"
                    key={cat.id}
                    onClick={() =>
                      navigate(
                        `/categorias/${cat.ordem}`
                      )
                    }
                  >
                    <img
                      className="IntroBannerCategorias-image"
                      src={
                        cat.imagem
                      }
                      alt={
                        cat.nome
                      }
                    />
                  </div>
                )
              )}
            </div>
          </div>

          {podeDireita && (
            <button
              className="IntroBannerCategorias-scrollBtn IntroBannerCategorias-scrollBtn-right"
              onClick={
                scrollRight
              }
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          )}
        </>
      )}

      {abrirAdmin && (
        <div
          className="admin-modal-overlay"
          onClick={() =>
            setAbrirAdmin(false)
          }
        >
          <div
            className="admin-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <AdminBannerCategoria
              banners={
                categorias
              }
              atualizarBanners={
                atualizarBanners
              }
              onClose={() =>
                setAbrirAdmin(false)
              }
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default IntroBannerCategorias;